module.exports = __webpack_public_path__ + "static/snowball_festival-45be04088579710f0d6bce5a55fdf3f3.jpg";